import {
  Typography,
  Avatar,
  List,
  ListItemAvatar,
  ListItemText,
  ListItem,
  Paper,
  makeStyles,
} from "@material-ui/core";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ItemsState } from "../../redux/state";
import {
  formatUtcDate,
  standardDateFormats,
} from "@ofqual/portal-core/core/utils/dateUtils";
import { useLookup } from "@ofqual/portal-core/core/hooks";
import { cachedQualificationTypeService } from "../../services";
import { School } from "@material-ui/icons";

const SEARCH_STATE_KEY = "search";

const useStyles = makeStyles((theme) => ({
  active: {
    ...theme.list.itemPrimary,
  },
  submissionRowDetails: {
    paddingRight: "20px",
  },
}));

export const ItemsList: React.FC<{ state: ItemsState }> = ({ state }) => {
  const classes = useStyles();

  const { response } = state;
  const history = useHistory();
  const { pathname, search } = useLocation();
  const navigate = (id: string) =>
    history.push(`${pathname}/${id}`, { [SEARCH_STATE_KEY]: search });

  const [qualificationTypeLookups] = useLookup({
    service: cachedQualificationTypeService,
    id: "id",
    label: "description",
  });

  return (
    qualificationTypeLookups && (
      <Paper>
        <List disablePadding>
          {response.data.map((item, index) => (
            <React.Fragment key={item.id}>
              <ListItem
                button
                alignItems="flex-start"
                onClick={() => navigate(item.id)}
                divider
                className={classes.active}
                data-test="row"
              >
                <ListItemAvatar>
                  <Avatar>
                    <School />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography
                      component="span"
                      variant="h6"
                      color="textPrimary"
                    >
                      {item.title}
                    </Typography>
                  }
                  secondary={
                    <React.Fragment>
                      <Typography
                        component="span"
                        variant="body2"
                        color="textPrimary"
                        className={classes.submissionRowDetails}
                      >
                        <strong>Organisation:</strong> {item.organisationName}
                      </Typography>
                      <Typography
                        component="span"
                        variant="body2"
                        color="textPrimary"
                        className={classes.submissionRowDetails}
                      >
                        <strong>Type:</strong>{" "}
                        {qualificationTypeLookups.find(
                          (x) =>
                            x.id.toString() ===
                            item.qualificationType?.toString()
                        )?.label || item.qualificationType}
                      </Typography>
                      {item.qualificationNumber ? (
                        <Typography
                          component="span"
                          variant="body2"
                          color="textPrimary"
                          className={classes.submissionRowDetails}
                        >
                          <strong>Qualification number:</strong>{" "}
                          {item.qualificationNumber}
                        </Typography>
                      ) : null}
                      {item.qualificationReviewDate ? (
                        <Typography
                          component="span"
                          variant="body2"
                          color="textPrimary"
                          className={classes.submissionRowDetails}
                        >
                          <strong>Review date:</strong>{" "}
                          {formatUtcDate(
                            item.qualificationReviewDate,
                            standardDateFormats.DATE
                          )}
                        </Typography>
                      ) : null}
                    </React.Fragment>
                  }
                />
              </ListItem>
            </React.Fragment>
          ))}
        </List>
      </Paper>
    )
  );
};
